module.exports = __webpack_public_path__ + "static/media/logo3.8555af4e.png";